module.exports = __webpack_public_path__ + "img/donante-instituto-avant-garde.d958e872.jpeg";